export * from '@fluentui/theme/lib/colors/DefaultPalette';
